<template>
	<div class="buttonList">
		<div v-for="(item, index) in buttonList" :key="index">
			<el-button
				:style="{ width: butWidth }"
				v-bind="item"
				:type="item.type || 'primary'"
				v-if="item.isShow ? item.isShow(item) : true"
				@click="onClick(item)"
				>{{ item.text }}</el-button
			>
		</div>
	</div>
</template>

<script>
export default {
	name: 'buttonList',
	props: {
		buttonList: {
			type: Array,
			default: () => [],
		},
		butWidth: {
			type: String,
			default: 'none',
		},
	},
	methods: {
		onClick(item) {
			if (item.onClick) {
				item.onClick();
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.buttonList {
	display: flex;
	flex-direction: column;
	align-items: center;
	border-top: 1px solid #e3e3e0;
	padding-top: 10px;

	.el-button {
		margin: 10px 0;
	}
}
</style>
